import React, { useEffect, useState } from "react";
import { PostData } from "../../../Services/PostData";
import Secciones from "./LoadSections";
import LoadingSpinner from "../../../Assets/LoadingSpinner/LoadingSpinner";
import "./HomeButtons.css";

import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import Menu from "react-burger-menu/lib/menus/scaleDown";
import AccordionItem from "react-bootstrap/esm/AccordionItem";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import Card from "react-bootstrap/Card";
import LoadButtons from "./LoadButtons";

function HomeButtons(buttons) {
  const [homeButtons, setHomeButtons] = useState(buttons);
  const [loading, setLoading] = useState(true);
  const [homeB, setHomeB] = useState(buttons);

  useEffect(() => {
    if (localStorage.getItem("homeButtons") != null) {
      setLoading(false);
      setHomeButtons(JSON.parse(localStorage.getItem("homeButtons")));
      setHomeB(JSON.parse(localStorage.getItem("homeButtons")));
    }
  }, []);
  //console.log(loading);
  if (!loading) {
    return (
      <>
        {" "}
        <Accordion className="homeAccordion">
          {Object.keys(homeB).map((item, key) => {
            if (homeB[item].sID != 0) {
              return (
                <Accordion.Item
                  title={homeB[item].sNOMBRE}
                  eventKey={homeB[item].sID}
                  key={homeB[item].sID}
                  id="collasible-nav-dropdown"
                >
                  <Accordion.Header>{homeB[item].sNOMBRE}</Accordion.Header>
                  <Accordion.Body className="accordion-home-body">
                    <LoadButtons key={key} btn={homeB[item]} />
                  </Accordion.Body>
                </Accordion.Item>
              );
            } else {
              {
                return Object.keys(homeB[item].botones).map(
                  (subitem, subkey) => {
                    if (subitem != "GROUPED") {
                      return <LoadButtons key={key} btn={homeB[item]} />;

                      return (
                        <Card key={2}>
                          <Card.Header
                            style={{ padding: "16px" }}
                            as={Link}
                            to={
                              homeB[item].botones[subitem].RInternal == ""
                                ? "/dashboard/" +
                                  homeB[item].botones[subitem].bINTNAME
                                : "/dashboard/" +
                                  homeB[item].botones[subitem].RInternal
                            }
                            key={homeB[item].botones[subitem].bID}
                            report={homeB[item].botones[subitem].RInternal}
                          >
                            {homeB[item].botones[subitem].bNOMBRE +
                              " " +
                              homeB[item].botones[subitem].bDESCRIPCION}
                          </Card.Header>
                        </Card>
                      );
                    }
                  }
                );
              }
            }
          })}
        </Accordion>
      </>
    );
  } else {
    return <LoadingSpinner />;
  }
}
export default HomeButtons;
